/* eslint-disable react/prop-types */
import { Tooltip, Button } from "antd";
import PopConfirm from "components/Common/PopConfirm";

const getColumns = ({ t }) => {
  const columns = [
    {
      filterable: false,
      resizable: false,
      sortable: false,
      width: 50,
      Header: t("STT"),
      Cell: state => (
        <div>{state.page * state.pageSize + state.viewIndex + 1}</div>
      ),
    },
    {
      accessor: "statMonth",
      Header: t("StatMonth"),
      width: 150,
      Cell: ({ value }) => (
        <Tooltip title={value}>
          <span className="text-truncate">{value}</span>
        </Tooltip>
      ),
    },
    {
      accessor: "instrumentID",
      Header: t("InstrumentID"),
      width: 150,
      Cell: ({ value }) => (
        <Tooltip title={value}>
          <span className="text-truncate">{value}</span>
        </Tooltip>
      ),
    },
    {
      accessor: "instrumentName",
      Header: t("InstrumentName"),
      width: 180,
      Cell: ({ value }) => (
        <Tooltip title={value}>
          <span className="text-truncate">{value}</span>
        </Tooltip>
      ),
    },
    {
      accessor: "mapMasterInstrumentID",
      Header: t("MasterInstrumentID"),
      width: 180,
      Cell: ({ value }) => (
        <Tooltip title={value}>
          <span className="text-truncate">{value}</span>
        </Tooltip>
      ),
    },
    {
      accessor: "masterInstrumentName",
      Header: t("MasterInstrumentName"),
      width: 180,
      Cell: ({ value }) => (
        <Tooltip title={value}>
          <span className="text-truncate">{value}</span>
        </Tooltip>
      ),
    },
    {
      accessor: "testCode",
      Header: t("TestCode"),
      width: 150,
      Cell: ({ value }) => (
        <Tooltip title={value}>
          <span className="text-truncate">{value}</span>
        </Tooltip>
      ),
    },
    {
      accessor: "testName",
      Header: t("TestName"),
      width: 200,
      Cell: ({ value }) => (
        <Tooltip title={value}>
          <span className="text-truncate">{value}</span>
        </Tooltip>
      ),
    },
    {
      accessor: "mapMasterTestcode",
      Header: t("MasterTestcode"),
      width: 180,
      Cell: ({ value }) => (
        <Tooltip title={value}>
          <span className="text-truncate">{value}</span>
        </Tooltip>
      ),
    },
    {
      accessor: "masterTestName",
      Header: t("MasterTestName"),
      width: 200,
      Cell: ({ value }) => (
        <Tooltip title={value}>
          <span className="text-truncate">{value}</span>
        </Tooltip>
      ),
    },
    {
      accessor: "masterCategory",
      Header: t("MasterCategoryCode"),
      width: 180,
      Cell: ({ value }) => (
        <Tooltip title={value}>
          <span className="text-truncate">{value}</span>
        </Tooltip>
      ),
    },
    {
      accessor: "locationID",
      Header: t("LocationID"),
      width: 150,
      Cell: ({ value }) => (
        <Tooltip title={value}>
          <span className="text-truncate">{value}</span>
        </Tooltip>
      ),
    },
    {
      accessor: "locationName",
      Header: t("LocationName"),
      width: 200,
      Cell: ({ value }) => (
        <Tooltip title={value}>
          <span className="text-truncate">{value}</span>
        </Tooltip>
      ),
    },
    {
      accessor: "countTest",
      Header: t("CountTest"),
      width: 150,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-end">
          <Tooltip title={value}>
            <span className="text-truncate">{value}</span>
          </Tooltip>
        </div>
      ),
    },
  ];

  return columns;
};

export default getColumns;
